import { keyframes } from 'styled-components';

const roadsqueeze = keyframes`
        50% {
            transform: translate(5%, 0); width: 90%;
        }
    `;

const carbounce = keyframes`
        50% {
            transform: translateY(-6px);
        }
    `;

const luggagebounce = keyframes`
        50% {
            transform: translateY(-6px);
        }
    `;

const rotate3 = keyframes`
        50% {
            transform: rotate(-2deg);
        }
    `;

const rotate2 = keyframes`
        50% {
            transform: rotate(-4deg);
        }
    `;

const rotate1 = keyframes`
        50% {
            transform: rotate(-6deg);
        }
    `;

const wheelshiftforward = keyframes`
        0% {
            transform: translate(1%, 0)}
        50% {
            transform: translate(0%, 0)}
        100% {
            transform: translate(1%, 0)}
    `;

const wheelshiftbackward = keyframes`
        0% {
            transform: translate(-1%, 0)}
        50% {
            transform: translate(0%, 0)}
        100% {
            transform: translate(-1%, 0)}

    `;

export { roadsqueeze, carbounce, luggagebounce, rotate3, rotate2, rotate1, wheelshiftforward, wheelshiftbackward };
